import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import Logo from "@/assets/logo.png";
import { Typography } from "@mui/material";

const LoadingPage = ({ loadingText = null }) => {
  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          p: 5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <img
            alt="Agribot logo"
            src={Logo}
            style={{ maxHeight: 200, alignSelf: "center" }}
          />
        </Box>
        {loadingText && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h6">{loadingText}</Typography>
          </Box>
        )}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      </Box>
    </Container>
  );
};

export default LoadingPage;
